<template>
  <img class="banner-image" src="../assets/banner.webp"/>


  <!--  <el-skeleton :rows="6" />-->
  <!--  <el-skeleton style="width: 240px" :loading="loading" animated>-->
  <!--  </el-skeleton>-->

  <div class="panel-div" v-show="!loading">
    <el-row>
      <el-col :span="24">
        <div class="adapter-title">{{newsInfo.title}}</div>
        <div class="adapter-description">{{locale[language.code].companynews.releaseTime+"："}}{{newsInfo.createTime}}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="archive-info" v-html="newsInfo.content">
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <router-link class="pre-link" v-if="neighbor && neighbor.pre" :underline="false" :to="'/companytechnologydetial/'+neighbor.pre.id" style="text-decoration: none;">
          <span>{{truncateStr(locale[language.code].companynews.preInfoTips +'：'+neighbor.pre.title,60)}}</span>
        </router-link>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <router-link class="next-link" v-if="neighbor && neighbor.next" :underline="false" :to="'/companytechnologydetial/'+neighbor.next.id" style="text-decoration: none;">
          <span>{{truncateStr(locale[language.code].companynews.nextInfoTips +'：'+neighbor.next.title,60)}}</span>
        </router-link>
      </el-col>
    </el-row>

    <div class="btn-group">
      <el-button class="oper-btn" type="primary" plain @click="backPage()">{{locale[language.code].companynews.pagebackbtnName}}</el-button>
    </div>

    <el-card class="box-card">
      <div  class="clearfix latest-title-header">
        <span>{{locale[language.code].companynews.latestInformation}}</span>
      </div>

      <router-link v-for="(item,index) in infoList" :key="item.id" :to="'/companytechnologydetial/'+item.id" style="text-decoration: none;display: block;">
        <div  class="info-list">
          <div class="adapter-name">{{(index+1)+'.'+item.title}}</div>
          <div class="adapter-time">{{item.createTime}}</div>
        </div>
      </router-link>

    </el-card>
  </div>



</template>

<script>
import{ companytechnologyById } from "@/api/CompanyTechnology";
import locale from "@/locale/locale";
import { truncateStr } from "@/utils/ruoyi";

export default {
  name: 'CompanyTechnologyDetail',

  props: {
    msg: String
  },
  data(){
    return {
      newsInfo:{},
      locale:locale,
      language:{},
      loading:true,
      neighbor:null,
      infoList:[],
      queryParams: {
        orderByColumn:"id",
        isAsc:"desc",
        pageNum: 1,
        pageSize: 10,
        title: null,
        id: null,
        languageId: null,

      },
    }
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    var languageStr = localStorage.getItem("website-language");

    if(!languageStr){
      var intervalIndex = setInterval(() =>{
        var languageStr = localStorage.getItem("website-language");
        if(languageStr){
          clearInterval(intervalIndex);
          this.language = JSON.parse(languageStr);
          this.initData();
        }
      },100);
    }else{
      this.language = JSON.parse(languageStr);
      this.initData();
    }
  },
  methods: {
    truncateStr(str,length){
      return truncateStr(str,length);
    },
    backPage(){
      window.history.back();
    },
    initData() {
      console.log(this.$route.params);
      this.queryParams.id = this.$route.params.id;
      this.queryParams.languageId = this.language.id;
      companytechnologyById(this.queryParams).then(res => {
        console.log(res);
        for(var tempIndex in res.data.list){
          if(res.data.list[tempIndex].languageId == this.language.id){
            this.newsInfo = res.data.list[tempIndex];
          }
        }
        this.loading =false;
        this.neighbor = res.data.neighbor;
        this.infoList = res.data.infoList.rows;



      });
    },
    changePage(target){
      console.log(target)
      // this.queryParams.pageNum = pageNum;
      // this.initData();
    },
    changePanel(index) {
      this.activeName = this.companyinfoList[index].title;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel-div{
  padding:20px 35px;
  margin:20px 20px;
  text-align: left;
}

.adapter-title{
  text-align: center;
  font-weight: bold;
  margin:10px 0px;
  font-size: 24px;
}

.adapter-description{
  margin-bottom: 20px;
  text-align: center;
  color:#696969;
}

.archive-info{
  text-align: left;
  text-indent: 2em;
}

.archive-info>>> img{
  display: block;
  margin: 10px auto;
  width:100%;
}


@media (max-width: 720px) {

  .panel-div{
    padding:20px 10px!important;
    margin:20px 0px!important;
  }
  .archive-info>>> img{
    display: block;
    margin: 10px auto;
    width:100%;
  }
}


.archive-info p,span{
  text-align: left;
}

.btn-group{
  margin:20px auto;
  text-align: center;
}
.btn-group .oper-btn{
  padding:20px 20px;
}

.pre-link{
  display: inline-block;
  text-align: left;
  font-weight: bold;
  margin-bottom: 20px;
}

.next-link{
  display: inline-block;
  width:100%;
  text-align: right;
  font-weight: bold;
  margin-bottom: 20px;
}

.latest-title-header{
  font-weight: bold;
  font-size: 20px;
}

.info-list{
  width:100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin:14px  0px;
  color:#363636;
}



</style>
